import type { LifecycleState } from "./types";

export interface LifecycleMeta {
  label: string;
  /** Plain-language meaning + why it changes how you read performance. */
  meaning: string;
}

/**
 * Lifecycle pills are neutral CONTEXT (not alerts) — rendered in brand blue
 * (`series1`), distinct from the red flags, grey diagnostics, and green Rising.
 */
export const LIFECYCLE_META: Record<LifecycleState, LifecycleMeta> = {
  new: {
    label: "New",
    meaning:
      "Recently created — still in its learning phase. Give it time to grow; don't judge the early numbers harshly.",
  },
  recently_modified: {
    label: "Modified",
    meaning:
      "Changed recently (budget / creative / targeting / status). Delivery resets after an edit — expect a few unsettled days before it stabilises.",
  },
  ending_soon: {
    label: "Ending soon",
    meaning:
      "Scheduled to end shortly — budget tapers and performance naturally dips. A decline here is expected, not a problem.",
  },
};

export const LIFECYCLE_ORDER: LifecycleState[] = ["new", "recently_modified", "ending_soon"];

export function buildLifecycleTooltip(state: LifecycleState): string {
  const m = LIFECYCLE_META[state];
  return `${m.label} — ${m.meaning}`;
}
